module.exports = __webpack_public_path__ + "static/media/mymontepio-registo.e483e14f.svg";